import * as React from "react";
import { FloatingFocusManager, FloatingList } from "@floating-ui/react";
import classnames from "classnames";
import { AnimatePresence, motion } from "motion/react";
import { useStackedHandleOnEscape } from "../../../../../../EscapeHandlerStack/hooks/EscapeHandlerStack/hooks/use-stacked-handle-on-escape.js";
import { useDropdownContext } from "../../../../../context/ButtonDropdown/context/ButtonDropdownContext.js";
const styleVariants = {
  enter: {
    opacity: 1,
    y: 0,
    overflow: "hidden",
    transitionEnd: { overflow: "" }
  },
  exit: {
    opacity: 0,
    y: -25,
    overflow: "hidden",
    transition: { duration: 0 }
  }
};
const ButtonDropdownContent = ({
  children,
  className,
  restoreFocus,
  type = "generic"
}) => {
  const {
    "aria-label": ariaLabel,
    close,
    cols,
    contentId,
    floatingProps: { itemsRef, getFloatingProps, floatingContext },
    isOpen
  } = useDropdownContext();
  useStackedHandleOnEscape({ isOpen, handler: close });
  const contentClassnames = classnames("button-dropdown-content__floating-container", className, {
    "button-dropdown-content__floating-container--is-open": isOpen
  });
  const handleKeyDown = (event) => {
    const firstOption = itemsRef.current[0];
    if (event.key === "Tab" && firstOption) {
      firstOption.focus();
    }
  };
  const selectRole = cols && cols > 1 ? "grid" : "listbox";
  const ariaRole = type === "select" ? selectRole : "dialog";
  return /* @__PURE__ */ React.createElement("div", { className: "button-dropdown-content", role: "presentation", tabIndex: -1 }, /* @__PURE__ */ React.createElement(AnimatePresence, null, isOpen && /* @__PURE__ */ React.createElement(FloatingFocusManager, { context: floatingContext, restoreFocus }, /* @__PURE__ */ React.createElement(
    motion.div,
    {
      initial: "exit",
      animate: "enter",
      exit: "exit",
      variants: styleVariants,
      className: contentClassnames,
      ref: floatingContext.refs.setFloating,
      "data-t": "button-dropdown-content",
      role: ariaRole,
      "aria-label": ariaLabel,
      id: contentId,
      style: {
        position: floatingContext.strategy,
        top: floatingContext.y ?? 0,
        left: floatingContext.x ?? 0
      },
      ...getFloatingProps({
        onKeyDown: handleKeyDown
      })
    },
    /* @__PURE__ */ React.createElement(FloatingList, { elementsRef: itemsRef }, children)
  ))));
};
export {
  ButtonDropdownContent
};
//# sourceMappingURL=ButtonDropdownContent.js.map
